import { Box } from "@mui/material";

interface CenterScreenProps {
  children: React.ReactNode;
}

const CenterScreen = ({ children }: CenterScreenProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100dvh",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default CenterScreen;
